export default "__VITE_ASSET__a8ee8cae__";